import { Table, ExpandableSection } from '@amzn/awsui-components-console';
import { AuditEvent } from '@amzn/awsdev-docs-virtual-smiley-conference-typescript-client';

interface AuditLogProps {
  auditLog?: AuditEvent[];
}

export const AuditLog = ({ auditLog }: AuditLogProps) => {
  if (!auditLog || auditLog.length === 0) {
    return <div>No Launch Task update history</div>;
  }

  const lastTenAuditEvents = auditLog.slice(-10);

  return (
    <Table
      columnDefinitions={[
        {
          id: 'caller',
          header: 'Caller',
          cell: (item) => item.caller,
        },
        {
          id: 'timestamp',
          header: 'Timestamp',
          cell: (item) => item.timestamp?.toLocaleString(),
        },
        {
          id: 'fieldName',
          header: 'Update',
          cell: (item) => (
            <ExpandableSection headerText={item.fieldName} variant='footer'>
              <div>
                <div>
                  <strong>Previous Value: </strong>"
                  {item.oldValue ?? <em>null</em>}"
                </div>
                <div>
                  <strong>Updated Value: </strong>"
                  {item.newValue ?? <em>null</em>}"
                </div>
                <div>
                  <strong>Updated by: </strong>
                  {item.user}
                </div>
              </div>
            </ExpandableSection>
          ),
        },
      ]}
      items={lastTenAuditEvents}
      sortingDisabled
    />
  );
};
